export const NEW_AD_USERS = 'newAdUsers';
export const typeOptions = {
  adVisit: {
    value: 'adVisit',
    label: 'Ad Visits'
  },
  [NEW_AD_USERS]: {
    value: NEW_AD_USERS,
    label: 'New Ad Users'
  },
}
